import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const Datenschutz = () => (
  <Layout>
    <SEOHead
      title="Datenschutz | heilys.info"
      description="Datenschutzerklärung von heilys.info: Informationen zur Verarbeitung personenbezogener Daten, Cookies und Affiliate-Links nach DSGVO."
      canonical="https://heilys.info/datenschutz"
      ogImageAlt="Datenschutzerklärung von heilys.info"
      noIndex={true}
      schemaJson={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Startseite", item: "https://heilys.info/" },
          { "@type": "ListItem", position: 2, name: "Datenschutz", item: "https://heilys.info/datenschutz" },
        ],
      }}
    />
    <div className="container py-16 md:py-24">
      <div className="mx-auto max-w-2xl">
        <nav aria-label="Breadcrumb" className="text-xs text-muted-foreground">
          <Link to="/" className="hover:text-foreground">Startseite</Link>
          <span className="mx-2">›</span>
          <span className="text-foreground">Datenschutz</span>
        </nav>
        <h1 className="mt-4 font-display text-3xl font-bold text-foreground">Datenschutzerklärung</h1>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <section>
            <h2 className="font-display text-base font-semibold text-foreground">1. Datenschutz auf einen Blick</h2>
            <p className="mt-2">
              Die folgenden Hinweise geben einen Überblick darüber, was mit deinen personenbezogenen Daten passiert, wenn du heilys.info besuchst. Personenbezogene Daten sind alle Daten, mit denen du persönlich identifiziert werden kannst. Wir nehmen den Schutz deiner persönlichen Daten sehr ernst und behandeln deine Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">2. Verantwortliche Stelle</h2>
            <p className="mt-2">Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
            <p className="mt-2">
              BENORA GROUP OOD<br />
              Hvoyna Str. 5<br />
              2700 Blagoevgrad, Bulgarien<br />
              E-Mail: info@longevity-hackers.de
            </p>
            <p className="mt-2">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">3. Datenerfassung auf dieser Website</h2>
            <h3 className="mt-3 text-sm font-medium text-foreground">Server-Log-Dateien</h3>
            <p className="mt-1">
              Der Hosting-Anbieter dieser Seite erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die dein Browser automatisch übermittelt. Dies sind unter anderem: Browsertyp und -version, verwendetes Betriebssystem, Referrer-URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage und die IP-Adresse. Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.
            </p>
            <h3 className="mt-3 text-sm font-medium text-foreground">Cookies</h3>
            <p className="mt-1">
              Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb der Seite erforderlich sind. Es werden keine Tracking-Cookies, Analyse-Cookies oder Werbe-Cookies eingesetzt. Ein technisch notwendiges Cookie speichert deine Cookie-Einstellung (Consent), damit der Cookie-Hinweis nicht bei jedem Seitenaufruf erneut erscheint. Dieses Cookie wird ausschließlich lokal in deinem Browser gespeichert (localStorage) und nicht an einen Server übermittelt.
            </p>
            <h3 className="mt-3 text-sm font-medium text-foreground">Kontaktaufnahme</h3>
            <p className="mt-1">
              Wenn du uns per E-Mail kontaktierst, werden deine Angaben inklusive der von dir angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne deine Einwilligung weiter. Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern deine Anfrage mit der Erfüllung eines Vertrags zusammenhängt, oder auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO bei sonstigen Anfragen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">4. Affiliate-Links und Partnerlinks</h2>
            <p className="mt-2">
              Diese Website enthält sogenannte Affiliate-Links (Partnerlinks) zu externen Online-Shops. Wenn du über einen solchen Link ein Produkt kaufst, erhalten wir eine Provision vom jeweiligen Anbieter. Für dich entstehen dadurch keine Mehrkosten. Beim Klick auf einen Affiliate-Link wirst du auf die externe Website des Anbieters weitergeleitet. Ab diesem Zeitpunkt gelten die Datenschutzbestimmungen des jeweiligen Anbieters. Wir haben keinen Einfluss auf die dort erhobenen Daten und verweisen auf die jeweilige Datenschutzerklärung des Shop-Betreibers.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">5. Hosting</h2>
            <p className="mt-2">
              Diese Website wird bei einem externen Dienstleister gehostet (Hosting-Anbieter). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich insbesondere um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe und sonstige Daten handeln, die über eine Website generiert werden. Der Einsatz des Hosters erfolgt im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">6. Deine Rechte</h2>
            <p className="mt-2">
              Du hast im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über deine gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie gegebenenfalls ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
            </p>
            <ul className="mt-2 list-inside list-disc space-y-1">
              <li><strong className="text-foreground">Auskunftsrecht (Art. 15 DSGVO):</strong> Du hast das Recht, eine Bestätigung darüber zu verlangen, ob dich betreffende personenbezogene Daten verarbeitet werden.</li>
              <li><strong className="text-foreground">Recht auf Berichtigung (Art. 16 DSGVO):</strong> Du hast das Recht, die Berichtigung unrichtiger oder die Vervollständigung unvollständiger Daten zu verlangen.</li>
              <li><strong className="text-foreground">Recht auf Löschung (Art. 17 DSGVO):</strong> Du hast das Recht, die Löschung deiner personenbezogenen Daten zu verlangen, sofern keine gesetzliche Aufbewahrungspflicht besteht.</li>
              <li><strong className="text-foreground">Recht auf Einschränkung (Art. 18 DSGVO):</strong> Du hast das Recht, die Einschränkung der Verarbeitung deiner Daten zu verlangen.</li>
              <li><strong className="text-foreground">Widerspruchsrecht (Art. 21 DSGVO):</strong> Du hast das Recht, jederzeit Widerspruch gegen die Verarbeitung deiner Daten einzulegen.</li>
              <li><strong className="text-foreground">Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Du hast das Recht, deine Daten in einem gängigen, maschinenlesbaren Format zu erhalten.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">7. Beschwerderecht bei der Aufsichtsbehörde</h2>
            <p className="mt-2">
              Wenn du der Ansicht bist, dass die Verarbeitung deiner personenbezogenen Daten gegen die DSGVO verstößt, hast du das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Du kannst dich dabei an die Aufsichtsbehörde deines gewöhnlichen Aufenthaltsortes, deines Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes wenden.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">8. Änderungen dieser Datenschutzerklärung</h2>
            <p className="mt-2">
              Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. Für deinen erneuten Besuch gilt dann die neue Datenschutzerklärung.
            </p>
          </section>

          <p className="mt-8 text-sm text-muted-foreground">
            Zurück zur{" "}
            <Link to="/#ueber-heilys" className="font-medium text-foreground underline underline-offset-2 hover:text-primary">
              heilys Marken-Übersicht
            </Link>{" "}
            oder zur{" "}
            <Link to="/" className="font-medium text-foreground underline underline-offset-2 hover:text-primary">
              heilys Rabattcode Startseite
            </Link>.
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

export default Datenschutz;
